import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/conference-system/jpg-png/reinvox-elegant-2.png")